import React from 'react';


export default function Media(){
    return (
        <div className='portr'>
            <div className='portc'>
                <video height="800" autoPlay loop muted>
                <source src="vaca.mp4" type="video/mp4"/>
                <source src="vaca.ogg" type="video/ogg"/>
                </video>
            </div>
            <div className='portc'>
                <img className='sm' src='BT_INSTA.png' height="600"/>
                <br/><br/><h3 className="smlink">Visit Molly's <a className='smlink2' href='https://mollyhoppy.com/'>WordPress Portfolio</a> for writing samples & links to influenced accounts</h3>
            </div>
        </div>
        )
}


//        <iframe width="560" height="315" src="https://www.youtube.com/embed/JHU4kMki97g?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe><br/><br/>
//        <iframe width="560" height="315" src="https://www.youtube.com/embed/t7Q3ca0M2oQ?controls=0&amp;start=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe><br/><br/>
//         <iframe width="560" height="315" src="https://www.youtube.com/embed/QoiSUdsjjMU?controls=0&amp;start=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>